import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserDomainService } from '@app/auth/domain/user-domain.service';

/**
 * Sends members who still owe onboarding into it before the Member Area mounts; the mirror of
 * `onboardingGuard`.
 *
 * Synchronous: `authInitializerProvider` blocks bootstrap on `users/me/`, and login loads the user
 * before navigating, so `user$$` is always populated by the time a navigation is evaluated. Must run
 * after `authGuard`, so signed-out visitors and staff are sent to login rather than to onboarding.
 */
export const membersAreaOnboardingGuard: CanActivateFn = () => {
  const router = inject(Router);
  const userDomainService = inject(UserDomainService);

  if (userDomainService.user$$()?.hasToShowOnboarding) {
    return router.parseUrl('/onboarding');
  }

  return true;
};
